var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56177 4.93066L6.44692 6.22573C7.89064 6.70695 8.95538 7.93949 9.22174 9.43778L11.5021 22.2648C11.8544 24.2463 13.5772 25.6899 15.5898 25.6899H31.4088C33.258 25.6899 34.8843 24.467 35.3975 22.6904L38.3961 12.3107C39.163 9.65584 37.1707 7.00659 34.4073 7.00659H15.0173",
    stroke: "#002970",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5865 36.0696C32.3062 36.0696 33.7004 34.6754 33.7004 32.9557C33.7004 31.236 32.3062 29.8418 30.5865 29.8418C28.8668 29.8418 27.4727 31.236 27.4727 32.9557C27.4727 34.6754 28.8668 36.0696 30.5865 36.0696Z",
    stroke: "#00BAF2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9794 36.0693C15.6991 36.0693 17.0932 34.6751 17.0932 32.9554C17.0932 31.2357 15.6991 29.8416 13.9794 29.8416C12.2596 29.8416 10.8655 31.2357 10.8655 32.9554C10.8655 34.6751 12.2596 36.0693 13.9794 36.0693Z",
    stroke: "#00BAF2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.8111f05e689d652ac1a1f71aecdd963a.svg";
export { ForwardRef as ReactComponent };